module.exports = __webpack_public_path__ + "static/img/new-77.57920e02.jpg";